import React from 'react';
import Swal from "sweetalert2";
import { showAlert } from 'helper';
import { UserPlanEnum } from 'Enums';
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import FormField from '@/shared/components/form/FormField';
import GeoAIAdminInterface from '@/utils/GeoAIAdminInterface';
import { Card, CardBody, CardTitleWrap, CardTitle, CardSubhead } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const required = value => (value !== undefined ? undefined : 'Required')

const EditGeoAIRequestLimit = (props) => {
    
    const sendGeoAIRequestLimit = (values) => {
        let geoAIRequestLimit = { ...values };
        geoAIRequestLimit.plan = UserPlanEnum[geoAIRequestLimit.plan]

        Swal.fire({
            title: 'Warning!',
            text: `This will edit a GeoAI request limit. Are you sure you want to continue?`,
            icon: 'warning',
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                GeoAIAdminInterface.instance.editGeoAIRequestLimit(geoAIRequestLimit).then(() => {
                    showAlert('success', 'Limit is editted!');
                }).catch((error) => {
                    showAlert('error', error.response?.data?.detail);
                });
            }
        });
    }

    const submitNewLimit = (values) => {
        sendGeoAIRequestLimit(values)
    };

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Edit GeoAI Request Limit</CardTitle>
                        <CardSubhead>This form edits a GeoAI request limit for a user plan.</CardSubhead>
                    </CardTitleWrap>
                    {props.request && <Form onSubmit={submitNewLimit} initialValues={{
                        plan: props.request.plan ? Object.keys(UserPlanEnum).find(key => UserPlanEnum[key] === props.request.plan) : '',
                        no_requests_per_month: props.request.no_requests_per_month,
                    }} >
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit}>
                                <FormGroup>
                                    <FormGroupLabel>Plan</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="plan" component={FormField} disabled ></Field>
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel># Requests / month</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="no_requests_per_month" component={FormField} validate={required} />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit">Submit</Button>
                                </FormButtonToolbar>
                            </FormContainer>
                        )}
                    </Form>}
                </CardBody>
            </Card>
        </Col>
    );
};

export default EditGeoAIRequestLimit;